"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
var moment_1 = __importDefault(require("moment"));
var DatePicker = function (_a) {
    var input = _a.input, placeholder = _a.placeholder, defaultValue = _a.defaultValue, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'DD.MM.YYYY' : _b, autoFocus = _a.autoFocus, _c = _a.className, className = _c === void 0 ? 'form-control' : _c;
    var value = input.value && moment_1["default"].utc(input.value, [dateFormat, 'YYYY-MM-DD', moment_1["default"].ISO_8601]) || null;
    var valueForPicker = value && value.format(dateFormat) || '';
    var handleChange = function (value, evt) {
        var formatted = value && moment_1["default"].utc(value, [dateFormat, 'YYYY-MM-DD', moment_1["default"].ISO_8601]);
        // @ts-ignore
        input.onChange(value && value.format('YYYY-MM-DD') || '', evt);
    };
    return (react_1["default"].createElement(react_datepicker_1["default"], __assign({}, input, { onChange: handleChange, locale: "de-de", dateFormat: dateFormat, className: "form-control", value: valueForPicker, 
        //  @ts-ignore
        selected: value, autoFocus: autoFocus })));
};
exports["default"] = DatePicker;
